import { useCallback } from 'react';

import { useMenuContext } from 'applications/GSP/pages/ParentHelper/components/History/hooks';
import { useParentHelperContext } from 'applications/GSP/pages/ParentHelper/providers/ParentHelperProvider/hooks';
import { scrollIntoView } from 'shared/utils/dom';

const SCROLL_TO_ACTIVE_CHAT_DELAY = 500;

export const useScrollToActiveChat = () => {
  const { chatId } = useParentHelperContext();
  const { anchorEl } = useMenuContext();

  return useCallback(() => {
    if (chatId === anchorEl?.id) {
      setTimeout(
        () =>
          scrollIntoView(
            document.getElementById(chatId)?.parentElement || null,
          ),
        SCROLL_TO_ACTIVE_CHAT_DELAY,
      );
    }
  }, [chatId, anchorEl?.id]);
};
